import { render, staticRenderFns } from "./SharerFeeTimeline.vue?vue&type=template&id=53a5c24c&scoped=true"
import script from "./SharerFeeTimeline.vue?vue&type=script&lang=js"
export * from "./SharerFeeTimeline.vue?vue&type=script&lang=js"
import style0 from "./SharerFeeTimeline.vue?vue&type=style&index=0&id=53a5c24c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a5c24c",
  null
  
)

export default component.exports